// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TAiH","content":"styles_content__cNpez","image":"styles_image__3PCfR","decorator":"styles_decorator__uXfBN"};